import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { authFlowLog } from '../services/auth-flow-log';
import {
  AuthStore,
  ROLE_ADMIN,
  ROLE_EDITOR,
  ROLE_VIEWER,
} from '../stores/auth.store';

const KNOWN_ROLES: readonly string[] = [ROLE_VIEWER, ROLE_EDITOR, ROLE_ADMIN];

export const authGuard = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  const authStore = inject(AuthStore);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authStore.isAuthenticated()) {
    const role = authStore.role();

    if (role !== null && KNOWN_ROLES.includes(role)) {
      return true;
    }

    authFlowLog(environment.debug, '7-guard:auth-unknown-role', { role });
    void router.navigate(['/403']);
    return false;
  }

  if (environment.allowLocalOneLoginLogin) {
    void authService.startLocalLogin(state.url);
    return false;
  }

  authService.redirectToPortal();
  return false;
};
